import DataUsageIcon from '@mui/icons-material/DataUsage';
import DoneIcon from '@mui/icons-material/Done';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  Typography,
  colors,
} from '@mui/material';

import React from 'react';
import Stripe from 'stripe';
import { numberAbbreviation } from '~/scripts/numberAbbreviation';
interface ApiPricingCardProps {
  title: string;
  description: string;
  tiers: Stripe.Plan.Tier[];
}
export const ApiPricingCard = ({
  title,
  description,
  tiers,
}: ApiPricingCardProps) => {
  return (
    <Card variant="outlined">
      <CardHeader title={title} sx={{ textAlign: 'center' }} />
      <CardContent>
        <Typography
          variant="body2"
          textAlign={'center'}
          dangerouslySetInnerHTML={{ __html: description }}></Typography>
        <List sx={{ pl: 0 }} dense>
          {tiers.map((tier, index) => {
            const from = tiers[index - 1]
              ? numberAbbreviation(
                  tiers[index - 1]!.up_to! + 1,
                  0
                ).toLocaleString()
              : '1';

            const to = !tier.up_to
              ? '+'
              : ` to ${numberAbbreviation(tier.up_to, 0).toLocaleString()}`;

            return (
              <React.Fragment key={index}>
                {index > 0 && <Divider />}
                <ListItem disableGutters>
                  <ListItemIcon>
                    {tier.unit_amount === 0 ? (
                      <DoneIcon color="info" />
                    ) : (
                      <DataUsageIcon color="info" />
                    )}
                  </ListItemIcon>
                  <Typography variant="body2" component="span">
                    {from}
                    {to}
                  </Typography>
                  <ListItemSecondaryAction>
                    {tier.unit_amount === 0 && (
                      <Typography
                        fontWeight={'bold'}
                        variant="body2"
                        component={'span'}
                        color={colors.green[500]}>
                        Free
                      </Typography>
                    )}
                    {tier.unit_amount! > 0 && (
                      <>
                        <Typography variant="body2" component="span">
                          ${(tier.unit_amount! / 100).toFixed(2)}
                        </Typography>
                        <Typography
                          variant="body2"
                          component="span"
                          color="grey">
                          {' '}
                          / request
                        </Typography>
                      </>
                    )}
                  </ListItemSecondaryAction>
                </ListItem>
              </React.Fragment>
            );
          })}
        </List>
      </CardContent>
    </Card>
  );
};
